/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Category_PlaceholderInputs */

const en_admin_posts_category_placeholder = /** @type {(inputs: Admin_Posts_Category_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select category`)
};

/**
* | output |
* | --- |
* | "Select category" |
*
* @param {Admin_Posts_Category_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_posts_category_placeholder = /** @type {((inputs?: Admin_Posts_Category_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Category_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_posts_category_placeholder(inputs)
});
export { admin_posts_category_placeholder as "admin.posts.category_placeholder" }